import React from 'react';
import { Container, Row, Col} from 'reactstrap';
import GiveUncontrolledCollapse from '../chrome/elements/collapsible/GiveUncontrolledCollapse';


const FAQPaMatching = () => (
	<Container style={{ paddingBottom: '2rem' }} className="p-0">
		<p className="text-center matching-heading">Frequently Asked Questions </p>
		<Row style={{ paddingBottom: '2rem' }}>
			<Col sm={12} md={12} lg={1} />
			<Col sm={12} md={12} lg={10} className="p-0">
				<GiveUncontrolledCollapse
					question="1. What happens if I choose to donate to an individual support program"
					answer="When you donate to an individual support program, <br/> &#9679; You will be assigned a specific beneficiary. You will receive details of the name, age, and the background of the person you will be supporting. <br/> &#9679; Your donations will be used to provide benefits to the person that you are assigned to by the nonprofit partner <br/> &#9679; You will receive an annual update about the person you support.  "
					className="give-faq-element"
					id="toggle1"
				/>
				<GiveUncontrolledCollapse
					question="2. Can I meet the beneficiary I support?"
					answer="Nonprofits mostly do welcome visitors to the communities they work with. Having said that, they do not allow the donors to visit the specific beneficiaries that they have supported or sponsored, as it can often give rise to awkward situations for the beneficiary."
					className="give-faq-element"
					id="toggle2"
				/>
				<GiveUncontrolledCollapse
					question="3. Can I send gifts to the beneficiary I support?"
					answer="Nonprofits have a number of beneficiaries that they support. It is an awkward situation for them to receive or give gifts to one specific person. If you really wish to send a gift, we would recommend something that the nonprofit can equally share with all their members and beneficiaries."
					className="give-faq-element"
					id="toggle3"
				/>
				<GiveUncontrolledCollapse
					question="4. Can I choose the beneficiary I want to support?"
					answer="The beneficiaries are assigned to donors through an automated system with basic checks on background and need. This is randomized and designed in such a way to maintain fairness. It is our mission to ensure that support through GiveIndia does not carry any bias with it <br/> We are sorry we will not be able to accommodate requests to choose the person you want to support."
					className="give-faq-element"
					id="toggle4"
				/>
				<GiveUncontrolledCollapse
					question="5. What kind of update will I receive? "
					answer="You will receive an annual update about the person you are helping. In addition, you will receive a periodic update about the nonprofit as well as the program that you are supporting."
					className="give-faq-element"
					id="toggle5"
				/>
			</Col>
			<Col sm={12} md={12} lg={1} />
		</Row>
		<style global jsx>{`

      .give-faq-element
        button {
          background: #F5F5F5;
          border: 1px solid #F5F5F5;
          color: #444444;
          font-weight: 600;
          box-shadow: none;
          width:100%;
          text-align: left;
          cursor: pointer;
          white-space: inherit;
          margin-bottom: 10px;
        }
        .give-faq-element
          button:hover {
            background: #F0F0F0;
            border: 1px solid #F0F0F0;
            color: #444444;
            transform: none;
            cursor: pointer;
          }
          .give-faq-element
            button:active {
              background-color: #F0F0F0 !important;
              border: 1px solid #F0F0F0 !important;
              color: #444444 !important;
              box-shadow: none !important;
              transform: none;
              cursor: pointer;
              outline: none;
            }
            .give-faq-element
              button:focus {
                background-color: #F0F0F0 !important;
                border: 1px solid #F0F0F0 !important;
                color: #444444 !important;
                box-shadow: none !important;
                transform: none;
                cursor: pointer;
                outline: none;
              }
          .give-faq-element .give-collapse-plus, .give-faq-element .give-collapse-minus {
            float: right;
            font-weight: 800;
            color: #666666;
          }
          .give-faq-element .collapse .give-collapse-minus {
            display: none;
          }
          .give-faq-element .collapse .show .give-collapse-minus {
            display: inline-block !important;
          }
          .give-faq-element .collapse .show .give-collapse-plus {
            display: none;
          }
          .give-faq-element .collapse {
            padding: 10px;
            padding-top: 0;
          }
    `}
		</style>
	</Container>
);


export default FAQPaMatching;
